import { Images } from 'assets/images';
import {
  ModalContent,
  ModalWrapper,
  CloseModalIcon,
  ConfirmPasswordText,
  ForYourSecurityText,
  InputWithButtons,
  PasswordInput,
  CancelAndSaveButtons,
  CancelButton,
  SaveButton,
} from 'admin/components/ProfileModals/styled';

export const ProfileConfirmModal = ({ handleConfirmModal }) => (
  <ModalWrapper>
    <CloseModalIcon src={Images.closeBlueIcon} onClick={handleConfirmModal} />
    <ModalContent>
      <ConfirmPasswordText>Confirm Password</ConfirmPasswordText>
      <ForYourSecurityText>
        For your security, please confirm your password to continue.
      </ForYourSecurityText>

      <InputWithButtons>
        <PasswordInput placeholder="Password" />
        <CancelAndSaveButtons>
          <CancelButton onClick={handleConfirmModal}>Cancel</CancelButton>
          <SaveButton onClick={handleConfirmModal}>Save</SaveButton>
        </CancelAndSaveButtons>
      </InputWithButtons>
    </ModalContent>
  </ModalWrapper>
);
